/* eslint-disable array-callback-return */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  Col,
  Icon,
  Modal,
  ModalFooter,
  Row,
  TextField,
  Tooltip,
} from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { FaEdit } from 'react-icons/fa';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { filter, map, remove } from 'lodash';
import FormFieldsGenerator from '../../../../../../../../shared/FormFieldsGenerator';

function EditItemsBatchModal({
  onClose,
  open,
  template,
  controlledVocab,
  fields,
  selectedItems,
  onUpdate,
}) {
  const selectedFields = filter(fields.value, (_, index) =>
    selectedItems.includes(index),
  );
  const filteredTemplate = template?.templateFields?.items.map((field) => {
    return {
      ...field,
      sectionFields: field.sectionFields
        .filter((item) => item.name !== 'barcode')
        .map((mappedField) => ({ ...mappedField, isRequired: false })),
    };
  });

  const renderFooter = (handleSubmit, pristine, submitting) => {
    return (
      <ModalFooter>
        <Button
          id="edit-batch-items-modal-btn"
          buttonStyle="primary"
          type="submit"
          onClick={(event) => {
            handleSubmit(event);
            onUpdate();
            onClose();
          }}
          disabled={pristine || submitting}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.editBatchItems"
            defaultMessage="Edit batch"
          />
        </Button>
        <Button id="edit-batch-modal-cancel-btn" onClick={onClose}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ModalFooter>
    );
  };

  const onHandleSubmit = (values, form) => {
    console.log('values: ', values);
    selectedFields.map((field) => {
      const fieldIndex = fields.value.findIndex(
        (fIndex) => fIndex.id === field.id,
      );
      fields.update(fieldIndex, {
        ...field,
        ...values,
      });
    });

    form.reset();
  };

  return (
    <Form
      onSubmit={onHandleSubmit}
      initialValues={{ itemDiscoverySuppress: false }}
      mutators={{
        ...arrayMutators,
      }}
      subscription={{ handleSubmit: true, pristine: true, submitting: true }}
    >
      {({ handleSubmit, pristine, submitting }) => {
        return (
          <Modal
            id="edit-batch-items-modal"
            open={open}
            onClose={onClose}
            footer={renderFooter(handleSubmit, pristine, submitting)}
            wrappingElement="form"
            label={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '7px',
                }}
              >
                <FaEdit size={18} />
                <FormattedMessage
                  id="ui-plugin-inventory-templates.editBatchItemsModal.label"
                  defaultMessage="Edit batch items"
                />
              </div>
            }
            size="large"
          >
            <form id="edit-items-batch-form" onSubmit={handleSubmit}>
              <FormFieldsGenerator
                key="edit-items-batch"
                formValues={filteredTemplate}
                // pageName={`${name}`}
                controlledVocab={controlledVocab}
              />
            </form>
          </Modal>
        );
      }}
    </Form>
  );
}

EditItemsBatchModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  template: PropTypes.object,
  controlledVocab: PropTypes.object,
  fields: PropTypes.object,
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  onUpdate: PropTypes.func,
};

export default EditItemsBatchModal;
